const firebaseConfig = {
  apiKey: "AIzaSyAv9O9G8d4TjKImQBmcRmCGFVMF_yen01o",
  authDomain: "linkedin-clone-a3f89.firebaseapp.com",
  projectId: "linkedin-clone-a3f89",
  storageBucket: "linkedin-clone-a3f89.firebasestorage.app",
  messagingSenderId: "67907898742",
  appId: "1:67907898742:web:a6e0ae9df15c8d84fb7e57",
  measurementId: "G-FV8L3YXVBY"
};

export default firebaseConfig;